export const StoreLocationInfoEnum = {
	locationName: ['locationName'],
	phoneNumber: ['phoneNumber'],
	address: ['address.line1', 'address.line2'],
	hours: ['hours.line1', 'hours.line2', 'hours.line3'],
};
